import React from "react";
import MoneyIcon from "@material-ui/icons/Money";
import { Card, CardBody } from "../../../../../../_metronic/_partials/controls";

export default function TotalDonationCount({ donationCount }) {
  return (
    <Card style={{height: '180px'}}>
      <CardBody>
        <h3 className="h3">
          <MoneyIcon className="mr-1" />
          Total Penerimaan Donasi
        </h3>
        <div className="d-flex justify-content-end">
          <div className="h1 m-5">{donationCount}</div>
        </div>
      </CardBody>
    </Card>
  );
}
